module.exports = __webpack_public_path__ + "img/5.45fcaec4.svg";